import React from 'react';
import { Link } from 'react-router';

import HeaderMenu from '../../../containers/HeaderMenu';
import Logo from '../../Logo';

import { srOnly } from '../../../base-styles/mixins.module.css';

import getUrl from '@/routes/routes/helpers/getUrl';
import RunnersWorldLogo from '../../RunnersWorldLogo';

import {
  logo,
  menu,
  logoWrapper,
  logoContainer,
  poweredBy,
  ldtContainer,
} from './styles.module.css';

/**
 * Partner Header presentational component.
 */
const PartnerHeader = (props) => {
  const { selectedLocale, userSelectedLocale, onPartnerLogoClick } = props;

  return (
    <React.Fragment>
      <div className={srOnly}>Let’s Do This</div>
      <div className={logoContainer}>
        <div className={logoWrapper} onClick={onPartnerLogoClick}>
          <RunnersWorldLogo black />
        </div>
        <div className={ldtContainer}>
          <span className={poweredBy}>Powered by</span>

          <Link
            to={getUrl.homepage(selectedLocale)}
            className={logo}
            title="Let’s Do This"
          >
            <Logo />
          </Link>
        </div>
      </div>
      <HeaderMenu
        narrow
        className={menu}
        selectedLocale={selectedLocale}
        userSelectedLocale={userSelectedLocale}
      />
    </React.Fragment>
  );
};

export default PartnerHeader;
